import useResource from "hooks/resources"
import { type ResourceResult } from "helpers/data-statuses"

interface Watchlist {
  id: string
  name: string
  description: string
  alias: string
  count: number
  lastUpdated: string
}

const WATCHLISTS_QUERY = `
  query { 
    watchlists {
      id
      name
      description
      alias
      count
      lastUpdated
    }
  }`

export function useWatchlists(): ResourceResult<Watchlist[]> {
  return useResource<Watchlist[]>({
    resource: "watchlists",
    url: () => ({
      id: "watchlists",
      query: WATCHLISTS_QUERY,
    }),
  }, "watchlists")
}
